import { render, staticRenderFns } from "./PantryItemCard.vue?vue&type=template&id=7278e124&scoped=true&"
import script from "./PantryItemCard.vue?vue&type=script&lang=ts&"
export * from "./PantryItemCard.vue?vue&type=script&lang=ts&"
import style0 from "./PantryItemCard.vue?vue&type=style&index=0&id=7278e124&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7278e124",
  null
  
)

export default component.exports